import { FUNCIONALIDADES_IMPORTACAO } from '@/app/core/models/permissao-lista.model'
import { MenuItem } from '@/app/core/models/menu.model'
import { environment } from '@/environments/environment'

const ROLES_INTERNOS = ['ADMINISTRADOR', 'USUARIO']

// Altere ao publicar novas versões dos PDFs da documentação, para o navegador não abrir a cópia em cache
const VERSAO_DOCUMENTACAO = '20261024'

export const MENU_ITEMS: MenuItem[] = [
  {
    key: 'principal',
    label: 'Menu Principal',
    isTitle: true,
    roles: ROLES_INTERNOS,
  },
  {
    key: 'dashboards',
    icon: 'iconoir-stats-up-square',
    label: 'Dashboards',
    collapsed: false,
    roles: ROLES_INTERNOS,
    subMenu: [
      {
        key: 'dashboard-analytics',
        label: 'Geral',
        url: '/dashboard/geral',
        parentKey: 'dashboards',
      },
      {
        key: 'contribuicoes',
        label: 'Consulta Ampla',
        url: '/contribuicoes',
        parentKey: 'dashboards',
      },
      {
        key: 'consulta-ampla-2',
        label: 'Consulta Ampla 2',
        url: '/consulta-ampla-2',
        parentKey: 'dashboards',
      },
      {
        key: 'site-v2',
        label: 'Site versão 2',
        url: environment.siteV2Url,
        parentKey: 'dashboards',
        isExternal: true,
      },
    ],
  },
  {
    key: 'lista-taxon',
    icon: 'iconoir-tree',
    label: 'Consulta Táxon',
    url: '/taxon',
    destaque: true,
  },
  {
    key: 'taxon-importar-contribuicoes',
    icon: 'iconoir-upload',
    label: 'Importar Dados Biológicos',
    url: '/taxon/importar-contribuicoes',
    roles: ['USUARIO_EXTERNO'],
  },
  {
    key: 'lista',
    icon: 'iconoir-list',
    label: 'Lista',
    collapsed: false,
    roles: ROLES_INTERNOS,
    subMenu: [
      {
        key: 'lista-grupo-lista',
        label: 'Grupo Lista',
        url: '/lista/grupo-lista',
        parentKey: 'lista',
      },
      {
        key: 'lista-lista',
        label: 'Lista',
        url: '/lista/lista',
        parentKey: 'lista',
      },
      {
        key: 'lista-usuario-lista',
        label: 'Usuário Lista',
        url: '/lista/usuario-lista',
        parentKey: 'lista',
      },
      {
        key: 'shape-listar',
        label: 'Shapes',
        url: '/lista/shape/listar',
        parentKey: 'lista',
        roles: ['ADMINISTRADOR'],
      },
    ],
  },
  {
    key: 'importacoes',
    label: 'Importações',
    collapsed: true,
    icon: 'fas fa-file-import',
    roles: ROLES_INTERNOS,
    funcionalidades: FUNCIONALIDADES_IMPORTACAO,
    subMenu: [
      {
        key: 'importacoes-taxon',
        label: 'Taxon',
        collapsed: true,
        parentKey: 'importacoes',
        subMenu: [
          {
            key: 'importacoes-taxon-importar',
            label: 'Importar arquivo',
            url: '/importacoes/taxon/importar',
            parentKey: 'importacoes-taxon',
          },
          {
            key: 'importacoes-taxon-importados',
            label: 'Já importados',
            url: '/importacoes/taxon/importados',
            parentKey: 'importacoes-taxon',
          },
        ],
      },
      {
        key: 'importacoes-ocorrencia',
        label: 'Ocorrência',
        collapsed: true,
        parentKey: 'importacoes',
        subMenu: [
          {
            key: 'importacoes-ocorrencia-importar',
            label: 'Importar arquivo',
            url: '/importacoes/ocorrencia/importar',
            parentKey: 'importacoes-ocorrencia',
          },
          {
            key: 'importacoes-ocorrencia-importados',
            label: 'Já importados',
            url: '/importacoes/ocorrencia/importados',
            parentKey: 'importacoes-ocorrencia',
          },
        ],
      },
    ],
  },
  {
    key: 'interoperabilidade',
    label: 'Interoperabilidade',
    collapsed: true,
    icon: 'iconoir-link',
    roles: ROLES_INTERNOS,
    funcionalidades: FUNCIONALIDADES_IMPORTACAO,
    subMenu: [
      {
        key: 'interoperabilidade-salve',
        label: 'SALVE',
        collapsed: true,
        parentKey: 'interoperabilidade',
        subMenu: [
          {
            key: 'interoperabilidade-salve-taxon',
            label: 'Taxon',
            collapsed: true,
            parentKey: 'interoperabilidade-salve',
            subMenu: [
              {
                key: 'interoperabilidade-salve-taxon-importar',
                label: 'Importar arquivo',
                url: '/interoperabilidade/salve/taxon/importar',
                parentKey: 'interoperabilidade-salve-taxon',
              },
              {
                key: 'interoperabilidade-salve-taxon-importados',
                label: 'Já importados',
                url: '/interoperabilidade/salve/taxon/importados',
                parentKey: 'interoperabilidade-salve-taxon',
              },
            ],
          },
          {
            key: 'interoperabilidade-salve-ocorrencia',
            label: 'Ocorrência',
            collapsed: true,
            parentKey: 'interoperabilidade-salve',
            subMenu: [
              {
                key: 'interoperabilidade-salve-ocorrencia-importar',
                label: 'Importar arquivo',
                url: '/interoperabilidade/salve/ocorrencia/importar',
                parentKey: 'interoperabilidade-salve-ocorrencia',
              },
              {
                key: 'interoperabilidade-salve-ocorrencia-importados',
                label: 'Já importados',
                url: '/interoperabilidade/salve/ocorrencia/importados',
                parentKey: 'interoperabilidade-salve-ocorrencia',
              },
            ],
          },
        ],
      },
      {
        key: 'interoperabilidade-cncflora',
        label: 'CNCFlora',
        url: '/interoperabilidade/cncflora',
        parentKey: 'interoperabilidade',
      },
    ],
  },
    {
    key: 'cadastros',
    label: 'Cadastros',
    collapsed: true,
    icon: 'iconoir-table-rows',
    roles: ['ADMINISTRADOR'],
    subMenu: [
      {
        key: 'table-acoes-conservacao',
        label: 'Ações Conservação',
        url: '/cadastros/acoes-conservacao',
        parentKey: 'cadastros',
      },
      {
        key: 'table-ameaca',
        label: 'Ameaças',
        url: '/cadastros/ameacas',
        parentKey: 'cadastros',
      },
      {
        key: 'table-bacia',
        label: 'Bacias',
        url: '/cadastros/bacias',
        parentKey: 'cadastros',
      },
      {
        key: 'table-bioma',
        label: 'Biomas',
        url: '/cadastros/biomas',
        parentKey: 'cadastros',
      },
      {
        key: 'table-forma-de-vida',
        label: 'Forma de Vida',
        url: '/cadastros/formas-vida',
        parentKey: 'cadastros',
      },
      {
        key: 'table-habitats',
        label: 'Habitats',
        url: '/cadastros/habitats',
        parentKey: 'cadastros',
      },
      {
        key: 'table-listas-vermelha',
        label: 'Listas Vermelha',
        url: '/cadastros/listas-vermelhas',
        parentKey: 'cadastros',
      },
      {
        key: 'table-pesquisas-necessarias',
        label: 'Pesquisas Necessárias',
        url: '/cadastros/pesquisas-necessarias',
        parentKey: 'cadastros',
      },
      {
        key: 'table-substrato',
        label: 'Substrato',
        url: '/cadastros/substratos',
        parentKey: 'cadastros',
      },
      {
        key: 'table-ucs',
        label: 'UCs',
        url: '/cadastros/ucs',
        parentKey: 'cadastros',
      },
      {
        key: 'table-usos',
        label: 'Usos',
        url: '/cadastros/usos',
        parentKey: 'cadastros',
      },
    ],
  },

  {
    key: 'admin',
    label: 'ADMIN',
    isTitle: true,
    roles: ['ADMINISTRADOR'],
  },
  {
    key: 'configuracao-sistema',
    label: 'Configuração',
    icon: 'iconoir-tools',
    url: '/configuracoes/instituicoes',
    roles: ['ADMINISTRADOR'],
  },
  {
    key: 'tabelas-sistema',
    label: 'Tabelas do sistema',
    collapsed: true,
    icon: 'iconoir-table-rows',
    roles: ['ADMINISTRADOR'],
    subMenu: [
      {
        key: 'table-categoria-ocorrencia',
        label: 'Categoria Ocorrência',
        url: '/tabelas-sistema/categorias-ocorrencia',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-categorias',
        label: 'Categorias',
        url: '/tabelas-sistema/categorias',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-criterio',
        label: 'Critério',
        url: '/tabelas-sistema/criterios',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-estado',
        label: 'Estados',
        url: '/tabelas-sistema/estados',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-funcao',
        label: 'Função',
        url: '/tabelas-sistema/funcoes',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-modulo',
        label: 'Módulo',
        url: '/tabelas-sistema/modulos',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-municipios',
        label: 'Municípios',
        url: '/tabelas-sistema/municipios',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-paises',
        label: 'Países',
        url: '/tabelas-sistema/paises',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-permissoes-papel',
        label: 'Permissões por Papel',
        url: '/tabelas-sistema/permissoes-papel',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-avaliacao',
        label: 'Situação Avaliação',
        url: '/tabelas-sistema/situacoes-avaliacao',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-lista',
        label: 'Situação Lista',
        url: '/tabelas-sistema/situacoes-lista',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-ocorrencia',
        label: 'Situação Ocorrência',
        url: '/tabelas-sistema/situacoes-ocorrencia',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-planilha',
        label: 'Situação Planilha',
        url: '/tabelas-sistema/situacoes-planilha',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-validacao',
        label: 'Situação Revisão',
        url: '/tabelas-sistema/situacoes-validacao',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-taxon',
        label: 'Situação Táxon',
        url: '/tabelas-sistema/situacoes-taxon',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-situacao-usuario',
        label: 'Situação Usuário',
        url: '/tabelas-sistema/situacoes-usuario',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-tipo-usuario',
        label: 'Tipo Usuário',
        url: '/tabelas-sistema/tipos-usuario',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-tipo-usuario-lista',
        label: 'Tipo Usuário Lista',
        url: '/tabelas-sistema/tipos-usuario-lista',
        parentKey: 'tabelas-sistema',
      },
      {
        key: 'table-erro-linhas',
        label: 'Tipos de Erros nas Linhas',
        url: '/tabelas-sistema/erros-linha',
        parentKey: 'tabelas-sistema',
      },
    ],
  },
  {
    key: 'documentacao',
    label: 'Documentação ',
    collapsed: true,
    icon: 'iconoir-folder',
    roles: ['ADMINISTRADOR'],
    subMenu: [
      {
        key: 'documentacao-historias',
        label: 'Histórias de Usuários',
        collapsed: true,
        parentKey: 'documentacao',
        subMenu: [
          ['README', 'Índice'],
          ['01-autenticacao', 'Autenticação'],
          ['02-perfil-e-navegacao', 'Perfil e Navegação'],
          ['03-dashboards', 'Dashboards'],
          ['04-consulta-ampla', 'Consulta Ampla'],
          ['05-lista', 'Lista'],
          ['06-taxon', 'Táxon'],
          ['07-ocorrencias', 'Ocorrências'],
          ['08-avaliacao', 'Avaliação'],
          ['09-ficha-especie', 'Ficha da Espécie'],
          ['10-contribuicao-externa', 'Contribuição Externa'],
          ['11-importacoes', 'Importações'],
          ['12-interoperabilidade', 'Interoperabilidade'],
          ['13-cadastros', 'Cadastros'],
          ['14-tabelas-sistema', 'Tabelas do Sistema'],
          ['15-acesso', 'Acesso'],
          ['16-configuracoes', 'Configurações'],
          ['17-relatorios', 'Relatórios'],
        ].map(([arquivo, label]) => ({
          key: `documentacao-historias-${arquivo}`,
          label,
          url: `assets/documentacao/historias-usuario/${arquivo}.pdf?v=${VERSAO_DOCUMENTACAO}`,
          parentKey: 'documentacao-historias',
          isExternal: true,
        })),
      },
      {
        key: 'documentacao-manual-configuracao',
        label: 'Manual de Configuração do Sistema',
        url: `assets/documentacao/manual-configuracao-sistema/manual-configuracao-sistema.pdf?v=${VERSAO_DOCUMENTACAO}`,
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'documentacao-diagrama',
        label: 'Diagrama de Classe',
        url: `assets/documentacao/diagrama-classe/diagrama-classe.pdf?v=${VERSAO_DOCUMENTACAO}`,
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'dicionario-dados',
        label: 'Dicionário de Dados',
        url: `assets/documentacao/dicionario-dados/dicionario-dados.pdf?v=${VERSAO_DOCUMENTACAO}`,
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'documentacao-plano-permissoes',
        label: 'Plano de Permissões',
        url: `assets/documentacao/plano-permissoes/plano-permissoes.pdf?v=${VERSAO_DOCUMENTACAO}`,
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'documentacao-conformidade',
        label: 'Relatório de Conformidade (Anexo I)',
        url: `assets/documentacao/conformidade-anexo-i/conformidade-anexo-i.pdf?v=${VERSAO_DOCUMENTACAO}`,
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'documentacao-guia-layout',
        label: 'Especificação de Layout',
        url: 'assets/documentacao/guia_layout.pdf',
        parentKey: 'documentacao',
        isExternal: true
      },
      {
        key: 'documentacao-implantacao',
        label: 'Documento de Implantação',
        url: 'assets/documentacao/documento_implantacao.pdf',
        parentKey: 'documentacao',
        isExternal: true
      },
    ],
  },
  {
    key: 'acesso',
    label: 'Acesso',
    collapsed: false,
    icon: 'fas fa-user-lock',
    roles: ['ADMINISTRADOR'],
    subMenu: [
      {
        key: 'acesso-usuario',
        label: 'Usuário',
        url: '/acesso/usuarios',
        parentKey: 'acesso',
        roles: ['ADMINISTRADOR'],
      },
      {
        key: 'acesso-pessoas',
        label: 'Pessoas',
        url: '/acesso/pessoas',
        parentKey: 'acesso',
        roles: ['ADMINISTRADOR'],
      },
      {
        key: 'acesso-grupo-pessoas',
        label: 'Grupo Pessoas',
        url: '/acesso/grupo-pessoas',
        parentKey: 'acesso',
        roles: ['ADMINISTRADOR'],
      },
    ],
  },
  {
    key: 'relacesso-acesso',
    icon: 'iconoir-key',
    label: 'Logs',
    url: '/relatorios/logs',
    roles: ['ADMINISTRADOR'],
  },
  {
    key: 'termos-condicoes',
    icon: 'iconoir-page',
    label: 'Termo de Consentimento e LGPD',
    url: '/termos-condicoes',
  },
  {
    key: 'termo-confidencialidade',
    icon: 'iconoir-lock',
    label: 'Termo de Confidencialidade',
    url: '/termo-confidencialidade',
  },
  {
    key: 'download-planilha',
    icon: 'iconoir-table',
    label: 'Planilhas',
    collapsed: false,
    subMenu: [
      {
        key: 'download-planilha-contribuicao',
        label: 'Planilha de dados biológicos',
        url: '/planilhas-modelo/contribuicao',
        parentKey: 'download-planilha',
        roles: ['USUARIO_EXTERNO'],
      },
      {
        key: 'download-planilha-ocorrencias',
        label: 'Planilha de ocorrências',
        url: '/planilhas-modelo/ocorrencias',
        parentKey: 'download-planilha',
        roles: ['USUARIO_EXTERNO'],
      },
    ],
  },
]
